(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Eldora: All / Perfumes / Bundles tabs swap the product grid in place instead of reloading the page.
     Each tab's grid is fetched once with the Section Rendering API and kept, so switching back is instant. */
  const eldoraTabCache = new Map();

  function eldoraFetchTab(href, sectionId) {
    if (!eldoraTabCache.has(href)) {
      const requestUrl = new URL(href, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);
      const request = fetch(requestUrl, { priority: 'low' })
        .then((response) => {
          if (!response.ok) throw new Error(`Tab request failed: ${response.status}`);
          return response.text();
        })
        .catch((error) => {
          eldoraTabCache.delete(href);
          throw error;
        });
      eldoraTabCache.set(href, request);
    }
    return eldoraTabCache.get(href);
  }

  async function eldoraShowTab(href, sectionId, { push }) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    const current = section?.querySelector('results-list');
    if (!current) {
      window.location.href = href;
      return;
    }
    section.setAttribute('data-eldora-loading', '');
    try {
      const html = await eldoraFetchTab(href, sectionId);
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('results-list');
      if (!next) throw new Error('Tab response had no product grid');
      current.replaceWith(next);
      if (push) history.pushState({ eldoraTab: sectionId }, '', href);
      const tabs = section.querySelector('eldora-collection-tabs');
      if (tabs && tabs.getBoundingClientRect().top < 0) {
        tabs.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    } catch (error) {
      window.location.href = href;
    } finally {
      section.removeAttribute('data-eldora-loading');
    }
  }

  class EldoraCollectionTabs extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.links = Array.from(this.querySelectorAll('a[data-eldora-tab]'));
      // Seed the cache with the page as first loaded; a swapped-in grid must not overwrite the old address
      if (!eldoraTabCache.has(window.location.href)) {
        eldoraTabCache.set(window.location.href, Promise.resolve(this.closest('.shopify-section')?.outerHTML ?? ''));
      }
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => this.onClick(event, link));
        // start loading every tab right away, at low priority, so even the first switch is instant
        this.preload(link);
      });
    }

    preload(link) {
      eldoraFetchTab(link.href, this.sectionId).catch(() => {});
    }

    onClick(event, link) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.classList.contains('is-active')) return;
      this.links.forEach((other) => {
        const active = other === link;
        other.classList.toggle('is-active', active);
        if (active) {
          other.setAttribute('aria-current', 'page');
        } else {
          other.removeAttribute('aria-current');
        }
      });
      eldoraShowTab(link.href, this.sectionId, { push: true });
    }
  }

  if (!customElements.get('eldora-collection-tabs')) {
    customElements.define('eldora-collection-tabs', EldoraCollectionTabs);
  }

  window.addEventListener('popstate', () => {
    const tabs = document.querySelector('eldora-collection-tabs');
    if (!tabs) return;
    eldoraShowTab(window.location.href, tabs.dataset.sectionId, { push: false });
  });

  } catch(e) { console.error(e); }
})();
})();
